import * as PIXI from 'pixi.js';
import { getActiveArrayShapeSnap, clearActiveArrayShapeSnap } from './arrayShapeSnapping';
import { getAdvanceRoofSelectingModel } from '__common/components/advancedSelecting/advanceSelecting';
import { getRenderer } from '../renderer/renderer';
import { getStage } from '../stage/stage';
import { snapIndicatorModel } from '__editor/googleMapsRoofsSelector/models/snapIndicator';
import { state, dispatch } from '__common/store';
import { CLEAR_ROOF_POINTS } from '__editor/googleMapsRoofsSelector/googleMapsRoofsSelectorActions';
import { SET_TOOLTIP_CONTENT } from '__common/components/tooltipCursor/tooltipCursorActions';
import { calcDistanceOfTwoPoints } from '__common/calculations/distanceBetweenTwoPoints';
import { metersToInches } from '__common/calculations/metersToInches';

let livePreviewContainer: PIXI.Container;
const LIVE_PREVIEW_ID = 'advanceSelectingLivePreview';

export const renderAdvanceSelectingOnStage = () => {
  const { advanceRoofSelecting: { roofPoints, lastPoint } } = state();
  const stage = getStage();
  const renderer = getRenderer();

  if (!stage || !renderer) return;

  if (!livePreviewContainer || livePreviewContainer.destroyed) {
    livePreviewContainer = new PIXI.Container();
    livePreviewContainer.id = LIVE_PREVIEW_ID;
    livePreviewContainer.sortableChildren = true;
    livePreviewContainer.zIndex = 99999;
  }

  if (livePreviewContainer.parent !== stage) {
    stage.addChild(livePreviewContainer);
  }

  livePreviewContainer.removeChildren();

  if (roofPoints.length && lastPoint) {
    const selection = getAdvanceRoofSelectingModel(stage.scale.x);
    if (selection) {
      selection.zIndex = 99998;
      livePreviewContainer.addChild(selection);
    }
    showTooltip();
  }

  const snappedVertex = getActiveArrayShapeSnap();
  if (snappedVertex) {
    const snapIndicator = snapIndicatorModel(snappedVertex, stage.scale.x);
    if (snapIndicator) {
      snapIndicator.zIndex = 99997;
      livePreviewContainer.addChild(snapIndicator);
    }
  }

  renderer.render(stage);
};

export const clearAdvanceSelecting = () => {
  const stage = getStage();
  const renderer = getRenderer();

  if (stage) {
    clearActiveArrayShapeSnap();
    if (livePreviewContainer && !livePreviewContainer.destroyed) {
      livePreviewContainer.removeChildren();
    }
    dispatch(CLEAR_ROOF_POINTS());
    dispatch(SET_TOOLTIP_CONTENT(null));
    if (renderer) renderer.render(stage);
  }
};

const showTooltip = () => {
  const { advanceRoofSelecting: { roofPoints, lastPoint, tempPoint }, background: { metersPerPixel } } = state();
  const lastPointOnStage: any = roofPoints[roofPoints.length - 1];
  let cursorPoint: any = lastPoint;
  if (tempPoint && tempPoint.x && tempPoint.y) cursorPoint = tempPoint;
  const distance = calcDistanceOfTwoPoints(lastPointOnStage, cursorPoint);
  const distanceInMeters = distance * metersPerPixel;
  const distanceInches = metersToInches(distanceInMeters);
  dispatch(SET_TOOLTIP_CONTENT(`${distanceInches.toFixed(2)}"`));
};
